// extracted by mini-css-extract-plugin
export var attachment = "_nv-a";
export var emailContainer = "_nv-4";
export var emailContentPaddedContainer = "_nv-b";
export var emailHeader = "_nv-6";
export var emailIframe = "_nv-3";
export var emailInfoIcon = "_nv-9";
export var emailShortenedSummary = "_nv-e";
export var infoDropdown = "_nv-0";
export var infoRowBoundedContent = "_nv-d";
export var internal = "_nv-5";
export var merchant = "_nv-8";
export var messageInputContainer = "_nv-h";
export var normal = "_nv-7";
export var replyCard = "_nv-f";
export var subtleButton = "_nv-1";
export var subtleButtonIconContainer = "_nv-2";
export var toggleViewRepliesButton = "_nv-c";
export var wrappingText = "_nv-g";